export default ({ backgroundColor = 'none', iconColor = 'white', style }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={backgroundColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M8.99822 12.3335H10.3316V10.3335H12.3316V9.00017H10.3316V7.00017H8.99822V9.00017H6.99822V10.3335H8.99822V12.3335ZM4.66489 13.3335V5.98351C4.66489 5.61684 4.79822 5.30573 5.06489 5.05017C5.33155 4.79462 5.64822 4.66684 6.01489 4.66684H13.3316C13.6982 4.66684 14.0121 4.79739 14.2732 5.05851C14.5343 5.31962 14.6649 5.63351 14.6649 6.00017V11.3335L11.3316 14.6668H5.99822C5.63155 14.6668 5.31766 14.5363 5.05655 14.2752C4.79544 14.0141 4.66489 13.7002 4.66489 13.3335ZM1.34822 4.16684C1.28155 3.80017 1.35377 3.46962 1.56489 3.17517C1.776 2.88073 2.06489 2.70017 2.43155 2.63351L9.66489 1.35017C10.0316 1.28351 10.3621 1.35573 10.6566 1.56684C10.951 1.77795 11.1316 2.06684 11.1982 2.43351L11.3649 3.33351H5.99822C5.26489 3.33351 4.63711 3.59462 4.11489 4.11684C3.59266 4.63906 3.33155 5.26684 3.33155 6.00017V12.3668C3.15377 12.2668 3.001 12.1335 2.87322 11.9668C2.74544 11.8002 2.66489 11.6113 2.63155 11.4002L1.34822 4.16684Z"
      fill={iconColor}
    />
  </svg>
)
